import styled from '@emotion/styled';

export const Banner = styled.div`
  position: relative;
  display: flex;
  min-height: 72px;
  padding: 16px;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  justify-content: space-between;
  border-radius: 8px;
  background-color: #cbe8c5;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;

export const BannerTitle = styled.div`
  color: var(--Neutral-Dark-Blue, #00223c);
  font-family: Nunito;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 21.6px;
  letter-spacing: 0.15px;
`;

export const BannerSubtitle = styled.div`
  color: var(--Neutral-Dark-Blue, #00223c);
  font-family: Nunito;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 0.1px;
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  overflow: hidden;
`;

export const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const BannerContent = styled.div`
  flex-grow: 1;
  max-width: 137px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 18px;
  background-color: #007ec3;
  opacity: 0.8;
  color: white;
  padding: 6px;

  svg {
    width: 30px;
    height: 30px;
  }
`;
